<!--suppress ALL -->
<template>
  <g-table :datas="datas" :columns="columns"
           ref="table"
           :frontEndPagination="frontEndPagination"
           :showNumbering="showNumbering"
           :selecteds.sync="selecteds"
           :selected-index.sync="selectedIndex"
           :perPage="perPage" :usePaging="usePaging"
           :totalData="totalData" :narrow="narrow"
           :bordered="bordered" :striped="striped"
           :isFullwidth="isFullwidth" :hoverable="hoverable"
           :isLoading="isLoading" :type="type" :class="className"
           @changePage="(page) => $emit('page-change', page)">
    <template slot="thead">
      <slot name="custom-tr"></slot>
      <tr v-if="!skipTheadRow">
        <th class="tooltip has-text-centered" style="width: 50px"
            data-tooltip="Select all" v-if="Array.isArray(selecteds)">
          <span>Pilih</span>
        </th>
        <th v-if="showNumbering" class="has-text-centered" style="width: 55px"><span>No</span></th>
        <g-table-column-head v-for="(column, index) in columns" :key="column.name"
                             :sorting="column.sorting" :th-index="index" :width="column.width"
                             :position="column.position" :th-key="column.key">
          {{column.name}}
        </g-table-column-head>
        <g-table-column-head v-if="$scopedSlots.action || $slots.action"
                             class="has-text-centered"
                             :sorting="false"
                             position="centered"
                             :th-index="-1">
          {{actionName}}
        </g-table-column-head>
      </tr>
    </template>
    <template slot-scope="{data, index}">
      <g-table-column v-for="(value, key, indexChild) in data"
                      :class="{'is-selected': Array.isArray(selecteds) && selecteds.some(item => item === index)}"
                      :label="columns[indexChild].name" :key="columns[indexChild].name+indexChild"
                      :position="columns[indexChild] && columns[indexChild].position">
        <template v-if="($scopedSlots.cell || $slots.cell) && showCustomColumn(indexChild)">
          <slot name="cell" :index="index" :indexData="indexChild" :keyData="key" :value="value"></slot>
        </template>
        <span v-else>{{value}}</span>
      </g-table-column>
      <g-table-column v-if="$scopedSlots.action || $slots.action">
        <g-field position="centered" is-grouped>
          <slot name="action" :index="index"></slot>
        </g-field>
      </g-table-column>
    </template>
    <template slot="empty">
      <template v-if="$scopedSlots.customEmpty || $slots.customEmpty">
        <slot name="customEmpty"></slot>
      </template>
      <div v-else class="has-no-content">
        <i class="fas fa-archive fa-5x"></i>
        <p class="title is-5">{{$t('text.no_content')}}</p>
      </div>
    </template>
  </g-table>
</template>

<script lang="ts">
  import {Component, Prop, Watch} from 'annotation';
  import PagingMixin from './common/table/PagingMixin';

  @Component
  export default class TableAction extends PagingMixin {

    @Prop({default: 'Aksi', type: String})
    public actionName: string;

    /**
     * index of row(baris).
     * if you want to custom the field of the row
     * fill it with index at the property
     */
    @Prop({default: []})
    public customColumns: Array<number>;

    @Prop({default: []})
    public columns: Array<string>;

    @Prop({default: true, type: Boolean})
    public showNumbering: boolean;

    @Prop({default: false, type: Boolean})
    public applyFixedThLeft: boolean;

    @Prop({default: null})
    public selecteds: any;

    @Prop({default: null})
    public selectedIndex: any;

    @Prop({default: []})
    public datas: Array<any>;

    @Prop({default: true, type: Boolean})
    public bordered: boolean;

    @Prop({default: false, type: Boolean})
    public striped: boolean;

    @Prop({default: false, type: Boolean})
    public narrow: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public hoverable: boolean;

    @Prop({default: false, type: Boolean})
    public isLoading: boolean;

    @Prop({default: 'info'})
    public type: string;

    @Prop({default: false, type: Boolean})
    public skipTheadRow: boolean;

    public showCustomColumn(index) {
      return this.customColumns.some(item => item === index);
    }

    @Watch('selecteds', {deep: true})
    public onSelectedsChange(val) {
      this.$emit('update:selecteds', val);
    }

    @Watch('selectedIndex', {deep: true})
    public onSelectedIndexChange(val) {
      this.$emit('update:selectedIndex', val);
    }

    public get className() {
      const {applyFixedThLeft} = this;

      return {
        'table-action': true,
        'apply-fixed-th-left': applyFixedThLeft
      };
    }

    public resetPaging() {
      this.currentPage = 1;
      if (this.$refs.table) {
        (this.$refs.table as any).currentPage = 1;
      }
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .table-action {
    .has-no-content {
      text-align: center;
      color: $grey-light;
      padding: 1rem;

      span, i, p {
        color: inherit;
      }

      i {
        margin-bottom: 1.5rem;
      }
    }

    table td, table th {
      vertical-align: middle;
    }

    &.apply-fixed-th-left {
      .g-table-wrapper {
        margin-left: 200px;
        overflow-x: scroll;
        overflow-y: visible;
        padding: 0;

        table {
          border-collapse: separate;
        }

        tr {
          position: initial;

          th, td {
            white-space: nowrap;
          }

          th:first-child, td:first-child {
            position: absolute;
            width: 200px;
            left: 0;
            top: auto;
            border-top-width: 1px;
            margin-top: -1px;
            border-right: 1px solid $grey-lighter;
            box-shadow: 1px 1px 3px $grey-lighter;
          }
        }
      }
    }
  }
</style>
